import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IndexComponent } from "./index/index.component";
import { ApploginComponent } from "./applogin/applogin.component";
import { AppcustomerlistComponent } from "./appcustomerlist/appcustomerlist.component";
import { AppkycdetailsComponent } from "./appkycdetails/appkycdetails.component";
import { TransactionsComponent } from "./transactions/transactions.component";
import { FiatTransactionsComponent } from "./fiattransactions/transactions.component";
import { LoginactivityComponent } from "./loginactivity/loginactivity.component";
//import { FiatactivityComponent } from "./fiatactivity/fiatactivity.component";
//import { CryptoactivityComponent } from "./cryptoactivity/cryptoactivity.component";
import { AdminTransactionsComponent } from "./admin-transactions/admin-transactions.component";
import { WithdrawComponent } from "./withdraw/withdraw.component";
import { FiatWithdrawComponent } from "./fiatwithdraw/fiatwithdraw.component";
import { OrderComponent } from "./order/order.component";
import { ManageadminComponent } from "./manageadmin/manageadmin.component";
import { GroupsComponent } from "./groups/groups.component";
import { ContentComponent } from "./_layout/content/content.component";
import { AnnouncementComponent } from "./announcement/announcement.component";

import { KycplansComponent } from "./kycplans/kycplans.component";
import { ManageAuctionConfigurationComponent } from "./manage-auction-configuration/manage-auction-configuration.component";
import { ManageipComponent } from './manageip/manageip.component'
import { CmsComponent } from './cms/cms.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { GeneratePasswordComponent } from './generate-password/generate-password.component';
import { ManualkycComponent } from './manualkyc/manualkyc.component';
import { ReferralconfigComponent } from './referralconfig/referralconfig.component';
import { ReferalhistoryComponent } from './referalhistory/referalhistory.component';
import { ReferralbonustransComponent } from './referralbonustrans/referralbonustrans.component';
import { CareersComponent } from "./careers/careers.component";
import { ContentManagementComponent } from "./content-management/content-management.component";
import { CandidatesComponent } from "./candidates/candidates.component";
import { HomeComponent } from "./home/home.component";
import { ManageAddressWhitelistComponent } from "./manage-address-whitelist/manage-address-whitelist.component";
import { LedgerComponent } from "./ledger/ledger.component";
import { ClientOrderReportComponent } from "./clientorderreport/clientorderreport.component";
import { AdminTradeMasterReportComponent } from "./admintrademaster/admintrademaster.component";
import { ClientTradeReportComponent } from "./clienttradereport/clienttradereport.component";
import { FireblockVaultComponent } from "./fireblockvault/fireblockvault.component";
import { FireblockAuditComponent } from "./fireblockaudit/fireblockaudit.component";
import { ExchangeTradeReportComponent } from "./exchangetradereport/exchangetradereport.component";
import { PositionBookComponent } from "./positionbook/positionbook.component";
import { ClearJunctionAuditComponent } from "./clearjunctionaudit/clearjunctionaudit.component";
import { whitelistedAddressComponent } from "./whitelistedAddress/whitelistedaddress.component";
import { depositAddressComponent } from "./deposit-address/deposit-address.component";
import { GetinTouchReportComponent } from "./getintouch/getintouch.component";
import { ClearJunctionTransactionsComponent } from "./clearjunctiontransactions/clearjunctiontransaction.component";
import { FireblockTransactionsComponent } from "./fireblocktransactions/fireblocktransactions.component";
import { FireblockSyncComponent } from "./fireblocksync/fireblocksync.component";
import { ExchangeDepositComponent } from "./exchangedeposit/exchangedeposit.component";
import { ExchangeWithdrawalComponent } from "./exchangewithdrawal/exchangewithdrawal.component";
import { CustomerListComponent } from "./customerlist/customerlist.component";
import { SidebarSubmenuComponent } from "./sidebar-submenu/sidebar-submenu.component";
import { WalletComponent } from "./wallet/wallet.component";
import { BankComponent } from "./bank/bank.component";
import { MarketPricesComponent } from "./marketprices/marketprices.component";
import { CollateralDepositComponent } from "./collateral-deposit/collateral-deposit.component";
import { SumsubAuditComponent } from "./sumsubaudit/sumsubaudit.component";
import { ClientAssetReportComponent } from "./clientassetreport/clientassetreport.component";
import { AMLBotAuditComponent } from "./amlbotaudit/amlbotaudit.component";

import { EquitasBankAuditComponent } from "./equitasbankaudit/equitasbankaudit.component";
import { EquitasBankTransactionsComponent } from "./equitasbanktransactions/equitasbanktransaction.component";

import { IndusindBankAuditComponent } from "./indusindbankaudit/indusindbankaudit.component";
import { IndusindBankTransactionsComponent } from "./indusindbanktransactions/indusindbanktransaction.component";

import { WithdrawBatchComponent } from "./withdraw-batch/withdrawbatch.component";

import { AutoWithdrawalComponent } from "./autowithdrawal/autowithdrawal.component";
import { HypervergeKYCAuditComponent } from "./hypervergekycaudit/hypervergekycaudit.component";

import { SettlementComponent } from "./settlement/settlement.component";
import { LoginLogsComponent } from "./loginlogs/loginlogs.component";

import { EmailValidateAuditComponent } from "./emailvalidateaudit/emailvalidateaudit.component";
import { ClientTransactionsComponent } from "./client-transactions/client-transactions.component";
import { TransactionsReportComponent } from "./transactionsreport/transactionsreport.component";
import { PayoutComponent } from "./payout/payout.component";

const routes: Routes = [
  //no layout routes
  { path: "", redirectTo: "/index", pathMatch: "full" },
  { path: "index", component: ApploginComponent },
  { path: "verifyemail/:str", component: ApploginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'generatepassword/:id', component: GeneratePasswordComponent },
  //Site routes goes here
  {
    path: "",
    component: ContentComponent,
    children: [
      { path: "", redirectTo: "/customer", pathMatch: "full" },
      { path: "home", component: IndexComponent },
      { path: "customer", component: AppcustomerlistComponent },
      { path: "submenu", component: SidebarSubmenuComponent },
      { path: "customers", component: CustomerListComponent },
      { path: "transactions", component: TransactionsComponent },
      { path: "fiattransactions", component: FiatTransactionsComponent },
      { path: "kyc/:id", component: AppkycdetailsComponent },
      { path: "customer/view/:id", component: AppcustomerlistComponent },
      { path: "login/activity", component: LoginLogsComponent },
      { path: "login/activity/:id", component: LoginactivityComponent },
      { path: "admin-transactions/:id", component: AdminTransactionsComponent },
      { path: "whitelistedAddress/:id", component: whitelistedAddressComponent },
      { path: "depositAddress/:id", component: depositAddressComponent },
      { path: "wallet/:id", component: WalletComponent },
      { path: "bank/:id", component: BankComponent },
      { path: "ledger/:id", component: LedgerComponent },
      { path: "withdraw", component: WithdrawComponent },
      { path: "fiatwithdraw", component: FiatWithdrawComponent },
      { path: "orders", component: OrderComponent },
      { path: "adminlist", component: ManageadminComponent },
      { path: "market-prices", component: MarketPricesComponent },
      // { path: "adminlist/edit/:id", component: ManageadminComponent },
      { path: "groups", component: GroupsComponent },
      { path: "careers", component: CareersComponent },
      { path: "homecms", component: HomeComponent },
      { path: "cms", component: ContentManagementComponent },
      { path: "candidates/:job_id", component: CandidatesComponent },
      { path: "announcement", component: AnnouncementComponent },
      { path: "auctionConfig", component: ManageAuctionConfigurationComponent },
      { path: "positionbook", component: PositionBookComponent },
      { path: "kycplans", component: KycplansComponent },
      { path: "clientorderreport", component: ClientOrderReportComponent },
      { path: "clientassetreport", component: ClientAssetReportComponent },
      { path: "admintradereport", component: AdminTradeMasterReportComponent },
      { path: "clienttradereport", component: ClientTradeReportComponent },
      { path: "exchangetradereport", component: ExchangeTradeReportComponent },
      { path: "manageips", component: ManageipComponent },
      { path: "contentmgmtsys", component: CmsComponent },
      { path: "userkyc/:id", component: ManualkycComponent },
      { path: "getintouch", component: GetinTouchReportComponent },
      { path: "referalconfig", component: ReferralconfigComponent },
      { path: "referralhistory", component: ReferalhistoryComponent },
      { path: "referralbonustrans", component: ReferralbonustransComponent },
      { path: "AddressWhitelist", component: ManageAddressWhitelistComponent },
      { path: "fireblockvault", component: FireblockVaultComponent },
      { path: "exchangedeposit", component: ExchangeDepositComponent },
      { path: "exchangewithdrawal", component: ExchangeWithdrawalComponent },
      { path: "fireblockaudit", component: FireblockAuditComponent },
      { path: "clearjunctionaudit", component: ClearJunctionAuditComponent },
      { path: "sumsubaudit", component: SumsubAuditComponent },
      { path: "hypervergekycaudit", component: HypervergeKYCAuditComponent },
      { path: "amlbotaudit", component: AMLBotAuditComponent },
      { path: "clearjunctiontransactions", component: ClearJunctionTransactionsComponent },
      { path: "fireblocktransactions", component: FireblockTransactionsComponent },
      { path: "fireblocksyncrequest", component: FireblockSyncComponent },
      { path: "collateral-deposit", component: CollateralDepositComponent },

      { path: "equitasbankaudit", component: EquitasBankAuditComponent },
      { path: "equitasbanktransactions", component: EquitasBankTransactionsComponent },

      { path: "indusindbankaudit", component: IndusindBankAuditComponent },
      { path: "indusindbanktransactions", component: IndusindBankTransactionsComponent },

      { path: "withdraw-batch", component: WithdrawBatchComponent },

      { path: "auto-withdraw", component: AutoWithdrawalComponent },

      { path: "settlement", component: SettlementComponent },

      { path: "email-validate-audit", component: EmailValidateAuditComponent },
      { path: "client-transactions", component: ClientTransactionsComponent },
      { path: "transactions-report", component: TransactionsReportComponent },
      { path: "payouts", component: PayoutComponent }

    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts